import React from "react";
import {
	BsCheckCircle,
	BsPencilSquare,
	BsTrash,
	BsXCircle,
	BsEye,
	BsEyeSlash
} from "react-icons/bs";
import './icon-action.css';

const actionIcons = {
	edit: BsPencilSquare,
	delete: BsTrash,
	activate: BsCheckCircle,
	inactivate: BsXCircle,
	view:  BsEye,
	viewOff: BsEyeSlash
};

const IconAction = ({ row, actions = [] }) => {
	return (
		<div className="icon-actions">
			{actions.map(action => {
				const Icon = action.icon || actionIcons[action.variant];

				if (!Icon) {
					return null;
				}

				const disabled = typeof action.disabled === "function"
					? action.disabled(row)
					: Boolean(action.disabled);

				const title = typeof action.title === "function"
					? action.title(row)
					: action.title;

				const ariaLabel = typeof action.ariaLabel === "function"
					? action.ariaLabel(row)
					: action.ariaLabel || title;

				return (
					<button
						key={action.key || action.variant}
						type="button"
						className={[
							"icon-actions__button",
							`icon-actions__button--${action.variant}`
						].filter(Boolean).join(" ")}
						title={title}
						aria-label={ariaLabel}
						disabled={disabled}
						onClick={() => action.onClick(row)}
					>
						<Icon size={18} />
					</button>
				);
			})}
		</div>
	);
};

export default IconAction;